import { useEffect, useState } from 'react'
import { MdSettings } from 'react-icons/md'

import { PersonalTrainer } from '~/components/Icons/PersonalTrainer'
import { AdminSettings as AdminSettingsType, getAdminSettings, togglePersonalTrainersModule } from '~/modules/adminSettings/services'

import { SettingsToggleItem } from '../../../../layout/admin/components/SideMenu/SettingsToggleItem'

export function AdminSettings() {
  const [openSections, setOpenSections] = useState<{ personalTrainers: boolean }>({
    personalTrainers: true,
  })
  const [settings, setSettings] = useState<AdminSettingsType>()
  const [loadingSettings, setLoadingSettings] = useState(true)
  const [toggling, setToggling] = useState(false)

  useEffect(() => {
    let mounted = true
    setLoadingSettings(true)
    getAdminSettings()
      .then((data) => {
        if (mounted && data) setSettings(data)
      })
      .finally(() => {
        if (mounted) setLoadingSettings(false)
      })
    return () => {
      mounted = false
    }
  }, [])

  return (
    <div className='flex-1 flex flex-col p-5 bg-slate-100 overflow-hidden'>
      <div className='overflow-y-auto max-h-full'>
        <h1 className='text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2'>
          <MdSettings size={28} />
          Configurações
        </h1>

        <div className='bg-white rounded-lg shadow-sm'>
          <div className='border-b border-gray-200'>
            <button
              className='flex items-center justify-between w-full text-left px-6 py-4 hover:bg-gray-50 transition-colors'
              onClick={() =>
                setOpenSections((s) => ({ ...s, personalTrainers: !s.personalTrainers }))
              }
            >
              <div className='flex items-center gap-3'>
                <PersonalTrainer size={24} />
                <span className='text-lg font-semibold text-gray-800'>Personal Trainers</span>
              </div>
              <svg
                className={`w-5 h-5 text-gray-500 transition-transform ${
                  openSections.personalTrainers ? 'rotate-180' : ''
                }`}
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M19 9l-7 7-7-7'
                />
              </svg>
            </button>
          </div>

          {openSections.personalTrainers && (
            <div className='px-6 py-4'>
              <SettingsToggleItem
                label='Cadastro de novos personal trainers'
                value={!!settings?.personalTrainersModule}
                loading={toggling || loadingSettings}
                disabled={loadingSettings}
                onChange={async () => {
                  setToggling(true)
                  const updated = await togglePersonalTrainersModule()
                  if (updated) setSettings(updated)
                  setToggling(false)
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
